<template>
  <div class="home">
    <div class="fixed-video">
      <video
        ref="videoPlayer"
        :src="videoSrc"
        loop
        controls
        controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
        disablePictureInPicture
        playsinline
        webkit-playsinline
        @contextmenu.prevent
      ></video>
    </div>
    <div class="banner">
      <div class="block" ref="mainDiv">
        <el-carousel trigger="click" height="100%" arrow="never">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
            <img style="width: 100%" :src="item.url" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="container production-center">
      <hgroup class="hgroup-title text-center">
        <h2 class="color333 marT10" style="font-weight: 900">核心技术</h2>
        <span></span>
      </hgroup>
      <ul class="item-wrap">
        <li class="clearfix">
          <p
            class="col-sm-6 col-md-6 col-lg-6 visible-sm visible-md visible-lg"
          >
            <img class="img-responsive" src="@/assets/technology.png" />
          </p>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xs-12 technology">
            <ul>
              <li>基于机器学习的视频多方法评估融合技术</li>
              <li>基于人眼显著性的视频压缩优化技术</li>
              <li>基于人类视觉心理模型的视频压缩优化技术</li>
              <li>基于机器学习的动态压缩优化技术</li>
              <li>基于机器学习的编码压缩模式选择技术</li>
              <li>基于机器学习的片源SR技术</li>
              <li>基于人眼显著性的视频增强技术</li>
              <li>基于人类视觉心理模型的视频增强技术</li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div class="container production-center">
      <hgroup class="hgroup-title text-center">
        <h2 class="color333 marT10" style="font-weight: 900">核心产品</h2>
        <span></span>
      </hgroup>
      <ul class="item-wrap">
        <li class="clearfix">
          <p
            class="col-sm-6 col-md-6 col-lg-6 visible-sm visible-md visible-lg"
          >
            <img class="img-responsive" src="@/assets/u14.png" />
          </p>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xs-12">
            <h3 class="color0c padL30">BES编转码系统</h3>
            <p class="tIndent2">
              BES编转码系统，基于观止研发的高质量数字视频压缩转换算法，结合观止先进的大规模集群管理调度系统，可为视频实时信号压缩转换、视频文件批量高速压缩转换提供高质量、高密度、高效的编转码解决方案。
            </p>
          </div>
        </li>
        <li class="clearfix">
          <p
            class="col-sm-6 col-md-6 col-lg-6 visible-sm visible-md visible-lg"
          >
            <img class="img-responsive" src="@/assets/u18.png" />
          </p>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xs-12">
            <h3 class="color0c padL30">超高清播出系统</h3>
            <p class="tIndent2">
              Bravo
              Playout全平台播出系统是一套运营级的音视频节目播出系统。系统支持实时直播流和视频文件混排编单播出，输入UDP-TS/HLS/RTMP/HTTP-TS/HTTP-FLV/HDS/DASH/HSS等
              多协议及MPEG/AVI/MKV/FLV/WMV/MP4/3GP/TS/RMVB/VOB/DAT
              等上百种主流文件格式，输出支持UDP-TS/HLS/RTMP/HTTP-TS/HTTP-FLV/HDS/DASH/HSS等多种协议,可广泛
              应用于DVB、IPTV、OTT、网站视频平台、移动视频平台等领域。
            </p>
          </div>
        </li>
        <li class="clearfix">
          <p
            class="col-sm-6 col-md-6 col-lg-6 visible-sm visible-md visible-lg"
          >
            <img class="img-responsive" src="@/assets/u20.png" />
          </p>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xs-12">
            <h3 class="color0c padL30">视频超分修复处理系统</h3>
            <p class="tIndent2">
              观止盘古视频超分修复处理系统，基于人工智能与大数据的有效结合，在海量数据中学习人物、场景、物体特征，对老旧影片内容，进行AI修复与视频超分，从而极致提升存量影片的视觉体验。
            </p>
          </div>
        </li>
        <li class="clearfix">
          <p
            class="col-sm-6 col-md-6 col-lg-6 visible-sm visible-md visible-lg"
          >
            <img class="img-responsive" src="@/assets/u19.png" />
          </p>
          <div class="col-sm-6 col-md-6 col-lg-6 col-xs-12">
            <h3 class="color0c padL30">内容生产系统</h3>
            <p class="tIndent2">
              Bravo
              Conductor内容生产平台是集节目导入、快编、技审、内容审核、转码、编目、发布等诸多功能于一体的专业运营级内容生产管理平台。平台基于“工作流”创新设计理念，具有高效的生产效率，支持一次生产制作多平台发布使用，可广泛应用于DVB、IPTV、OTT、网站
              视频平台、移动视频平台等领域
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="container clearfix">
      <hgroup class="hgroup-title text-center">
        <h2 class="color333 marT10" style="font-weight: 900">案例</h2>
        <span></span>
      </hgroup>
      <div class="cases-wrap" style="height: 200px">
        <ul
          class="cases-body pc-cases-body visible-sm visible-md visible-lg"
          style="height: 100%"
        >
          <b
            class="arrow arrow-left pull-left text-center pointer"
            href="javascript:;"
          >
            <i class="glyphicon el-icon-arrow-left"></i>
          </b>
          <li class="pull-left logos-wrap logo-show">
            <p class="row">
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/1.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/2.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/3.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/4.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/5.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/6.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/7.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/8.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/9.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/10.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/11.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/12.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/13.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/14.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/15.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/16.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/17.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/18.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/19.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/20.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT20" src="@/assets/index/21.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT20" src="@/assets/index/22.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/23.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/24.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marL10" src="@/assets/index/25.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/26.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/27.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/28.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/29.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive" src="@/assets/index/30.png"
              /></span>
            </p>
            <p>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/31.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/32.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/33.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/34.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img class="img-responsive marT30" src="@/assets/index/35.png"
              /></span>
              <span class="col-sm-2 col-md-2 col-lg-2"
                ><img
                  class="img-responsive marT30 marL30"
                  src="@/assets/index/36.png"
              /></span>
            </p>
          </li>
          <b
            class="arrow arrow-right pull-right text-center pointer"
            href="javascript:;"
          >
            <i class="glyphicon el-icon-arrow-right"></i>
          </b>
        </ul>
        <ul class="cases-body m-cases-body visible-xs" style="height: 100%">
          <b
            class="arrow arrow-left pull-left text-center pointer"
            href="javascript:;"
          >
            <i class="glyphicon el-icon-arrow-left"></i>
          </b>
          <li class="pull-left logo-show">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/1.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/2.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/3.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/4.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/5.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/6.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/7.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/8.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/9.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/10.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/11.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/12.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/13.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/14.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/15.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/16.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/17.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT20" src="@/assets/index/18.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/19.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/20.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/21.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/22.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/23.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT20" src="@/assets/index/24.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/25.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/26.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/27.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/28.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/29.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT20" src="@/assets/index/30.png"
              /></span>
            </p>
          </li>
          <li class="pull-left">
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/31.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/32.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive" src="@/assets/index/33.png"
              /></span>
            </p>
            <p class="row">
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/34.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT30" src="@/assets/index/35.png"
              /></span>
              <span class="col-xs-4"
                ><img class="img-responsive marT20" src="@/assets/index/36.png"
              /></span>
            </p>
          </li>
          <b
            class="arrow arrow-right pull-right text-center pointer"
            href="javascript:;"
          >
            <i class="glyphicon el-icon-arrow-right"></i>
          </b>
        </ul>
      </div>
      <!-- <a class="check text-center cases-more" href="html/cases.html"
        >查看更多</a
      > -->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bannerList: [
        {
          id: 0,
          url: require("@/assets/banner1.png"),
        },
        {
          id: 1,
          url: require("@/assets/banner2.png"),
        },
        {
          id: 2,
          url: require("@/assets/banner3.png"),
        }
      ],
      videoSrc: require("@/assets/guanzhi.mp4"),
      isPlaying: false,
      offsetWidth1: '',
      offsetWidth2: '',
      bannerHeight: null
    }
  },
  watch: {
    offsetWidth2 (val) {
      // if (this.offsetWidth1 < 767) {
      //   if (val > 767) {
      //     this.clientWidth1 = val
      //     this.$router.push({ name: 'empty' })
      //   } else {
      //     this.clientWidth = val
      //     this.$router.push({ name: 'empty' })
      //   }
      // } else {
      //   if (val < 767) {
      //     this.clientWidth1 = val
      //     this.$router.push({ name: 'empty' })

      //   } else {
      //     this.clientWidth1 = val
      //   }
      // }
      if (val !== this.offsetWidth1) {
        this.clientWidth1 = val
        this.$router.push({ name: 'empty' })
        // this.bannerHeight = 582 / 1903 * this.offsetWidth2;
        // console.log(this.bannerHeight);
      }
    },
    // bannerHeight(val){
    //   this.bannerHeightval = val
    // }
  },
  mounted () {
    this.setSize()
    window.addEventListener('resize', this.setSize)
    this.offsetWidth1 = document.body.offsetWidth
    window.onresize = () => {
      return (() => {
        this.offsetWidth2 = document.body.offsetWidth
        // this.setSize()
      })()
    }
    this.logoShow()
    this.banner()
    this.hideOverflowMenu()
    var aLogobox = $('.cases-wrap')
    if ($('.cases-body').width() > 767) {
      var aLogo = $('.pc-cases-body li')
    } else {
      var aLogo = $('.m-cases-body li')
    }
    var aPrev = $('.arrow-left')
    var aNext = $('.arrow-right')
    var n = 0
    var timer = null

    var k = 0
    var timer2 = null
    var activityLis = $('.activity-img-body li')
    activityLis.each(function () {
      $(this).mouseover(function () {
        clearInterval(timer)
        k = $(this).index()
        tab(k)
      })
    })
    tick2()
    function tick2 () {
      timer2 = setInterval(function () {
        k++
        if (k >= activityLis.length) k = 0
        tab2(k)
      }, 3000)
    }
    function tab2 (m) {
      activityLis.eq(m).show().siblings().hide()
    }

    aLogo.each(function () {
      $(this).mouseover(function () {
        clearInterval(timer)
        n = $(this).index()
        tab(n)
      })
    })

    aNext.click(function () {
      n++
      if (n >= aLogo.length) n = 0
      tab(n)
      clearInterval(timer)
    })

    aPrev.click(function () {
      n--
      if (n == -1) n = aLogo.length - 1
      tab(n)
      clearInterval(timer)
    })

    tick()

    aLogobox.mouseover(function () {
      clearInterval(timer)
    })

    aLogobox.mouseout(function () {
      tick()
    })

    aLogobox.focus(function () {
      clearInterval(timer)
    })

    aLogobox.blur(function () {
      tick()
    })

    function tab (m) {
      aLogo.eq(m).addClass('logo-show').siblings().removeClass('logo-show')
    }

    function tick () {
      timer = setInterval(function () {
        n++
        if (n >= aLogo.length) n = 0
        tab(n)
      }, 3000)
    }
  },
  destroyed () {
    window.removeEventListener('resize', this.getDivHeight, false)
  },
  methods: {
    toggleVideo () {
      const video = this.$refs.videoPlayer
      if (this.isPlaying) {
        video.pause()
        this.isPlaying = false
      } else {
        video.play()
        this.isPlaying = true
      }
    },
    logoShow () {
      var aLogobox = $('.case')
      console.log(aLogobox)
    },
    banner () {
      $('#myCarousel').carousel({
        interval: 5000,
      })
    },
    setSize () {
      const screenheight = document.body.offsetWidth
      // 通过屏幕宽度(图片宽度)计算高度
      this.$refs.mainDiv.style.height = 582 / 1903 * screenheight + 'px'
    },
    hideOverflowMenu () {
      const video = this.$refs.videoPlayer
      if (video && video.disablePictureInPicture !== undefined) {
        video.disablePictureInPicture = true
      }
    },

  }
}


</script>



<style lang="less" scoped>
.fixed-video {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 18%;
  // height: 135px;
  z-index: 999;
  cursor: pointer;
  background: #000;
  // border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 55%;
      transform: translate(-50%, -50%);
      border-style: solid;
      border-width: 8px 0 8px 14px;
      border-color: transparent transparent transparent #fff;
    }
  }
}
.item {
  margin-top: 0;
}
/deep/ .el-carousel__indicators {
  // 指示器
  /* left: unset; */
  // left: 0;
  // transform: unset;
  // right: 2%;
  // bottom: 20%;
  // z-index: 99;
  // margin: 0 16px;
  // width: calc(100% - 32px);
}

/deep/ .el-carousel__button {
  // 指示器按钮
  // width: 16px;
  // height: 2px;
  background-color: rgba(115, 111, 111, 0.3);
}

/deep/ .is-active .el-carousel__button {
  // 指示器激活按钮
  background: #5ec3ef;
}
.technology {
  li {
    line-height: 50px;
    font-size: 22px;
    letter-spacing: 3px;
  }
  li:before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #000;
    border-radius: 50%;
    margin-right: 20px;
  }
}
.el-carousel {
  height: 100%;
}
.el-carousel__container {
  height: 100%;
}
</style>

<style lang="less">
.fixed-video video::-webkit-media-controls-fullscreen-button {
  display: none !important;
}
.fixed-video video::-webkit-media-controls-overflow-button {
  display: none !important;
}
.fixed-video video::-internal-media-controls-overflow-button {
  display: none !important;
}
.fixed-video video::-webkit-media-controls-overflow-menu-button {
  display: none !important;
}
</style>
